import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-gn-progress-circle',
  templateUrl: './gn-progress-circle.component.html',
  styleUrls: ['./gn-progress-circle.component.scss']
})
export class GnProgressCircleComponent implements OnInit {
  @Input('requiredPoints') requiredPoints;
  @Input('points') points;
  public progress:number = 0;

  constructor() { }

  ngOnInit() {
    let percent=Math.floor((100/this.requiredPoints)*this.points);
    if(percent>100){percent=100;}

    this.progress = percent;
  }

}
